module.exports = __webpack_public_path__ + "6fb1ba5c097e1ea275f298bb4ed61b79.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/nachos.png
// module id = 3026
// module chunks = 0